const initialState = {
    threads: [],
    wazzup_type: 'all',
    pagination: {
        pagination_has_next_page: null,
        pagination_current_page: null,
        pagination_total: null,
    },
    chat_popup: {
        id: null,
        old_scroll: 0
    }
}

export default function chat(state = initialState, action) {
    switch(action.type) {

        case 'SET_WAZZUP_TYPE':
            return {
                ...state,
                wazzup_type: action.payload
            }

        case 'SET_THREADS':
            return {
                ...state,
                threads: [...action.payload.threads, ...state.threads],
                pagination: {
                    pagination_has_next_page: action.payload.pagination_has_next_page,
                    pagination_current_page: action.payload.pagination_current_page,
                    pagination_total: action.payload.pagination_total,
                }
            }

        case 'REPLACE_ALL_THREADS':
            return {
                ...state,
                threads: action.payload.threads,
                pagination: {
                    pagination_has_next_page: action.payload.pagination_has_next_page,
                    pagination_current_page: action.payload.pagination_current_page,
                    pagination_total: action.payload.pagination_total,
                }
            }
   
        
        case 'APPEND_THREADS':
            return {
                ...state,
                threads: [...state.threads, ...action.payload.threads],
                pagination: {
                    pagination_has_next_page: action.payload.pagination_has_next_page,
                    pagination_current_page: action.payload.pagination_current_page,
                    pagination_total: action.payload.pagination_total,
                }
            }    
            
        case 'SET_CHAT_POPUP':
            return {
                ...state,
                chat_popup: {
                    id: action.payload.id,
                    old_scroll: action.payload.old_scroll
                }
            }
        
        default:
            return state 
    }
}